// extracted by mini-css-extract-plugin
export default {"container":"FileUploadModal_container__bDScZ","header":"FileUploadModal_header__WxMvR","close":"FileUploadModal_close__kNDv4","dropfiles":"FileUploadModal_dropfiles__dpPde"};